// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__nKEg0"};